import { NitrogenGeneratorDataBM } from '../types/BusinessModel/NitrogenGeneratorDataBM';
import { NitrogenGeneratorData } from '../types/ViewModel/NitrogenGeneratorData';

export class NitrogenGeneratorDataFactory {
    public create(data: NitrogenGeneratorDataBM): NitrogenGeneratorData {
        return new NitrogenGeneratorData(data.generatorId, data.runningHours, data.runningHoursLoaded, data.runningHoursUnloaded);
    }

    public createList(data: NitrogenGeneratorDataBM[]): NitrogenGeneratorData[] {
        return data.map((h) => this.create(h));
    }
}
